/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCommentBase } from './BaseCommentBase';
import { CommentReply } from './CommentReply';
const BaseCommentBaseWithNormalRepliesParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['replies', /* #__PURE__ */ codecArray(CommentReply)],
]), BaseCommentBase);
export class BaseCommentBaseWithNormalReplies extends BaseCommentBase {
    static decode(input) {
        return BaseCommentBaseWithNormalRepliesParser.decode(input).map(res => new BaseCommentBaseWithNormalReplies(res));
    }
    static unsafeDecode(input) {
        return BaseCommentBaseWithNormalReplies.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseCommentBaseWithNormalRepliesParser.encode(data);
    }
    static schema() {
        return BaseCommentBaseWithNormalRepliesParser.schema();
    }
}
